var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { panoramaViewer } from "./utils/panoramaViewer";
import { DURATIONS, ROTATIONS } from "./utils/standardPanoramaViewerData";
import { inputRotationToQuaternion } from "../framework/utils";
import { defaultRendererConfig } from "./index";
export function panoramaView3(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Panorama View 3" +
                "</h1>" +
                "<p>" +
                "The entire view will be replaced with a panoramic image, that should render normally. This test will show an " +
                "alpha blended composite of the previous two panoramas, with the second being rotated by 180 degrees." +
                "</p>";
        yield panoramaViewer(defaultRendererConfig(container), DURATIONS, ROTATIONS, (renderer) => __awaiter(this, void 0, void 0, function* () {
            const pano1 = yield renderer.getObjectFactory().createPanorama({
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/pano/R0011230.JPG",
            });
            pano1.setOpacity(0.2);
            pano1.setPriority(0);
            renderer.getWorld().addPanorama(pano1);
            const pano2 = yield renderer.getObjectFactory().createPanorama({
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/pano/R0011235.JPG",
                rotation: {
                    type: "explicit",
                    quaternion: inputRotationToQuaternion([0, Math.PI, 0]),
                },
            });
            pano2.setOpacity(0.5);
            pano2.setPriority(1);
            renderer.getWorld().addPanorama(pano2);
        }));
    });
}
